import { space } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';

export const streamBannerNotFound = style({ padding: space.s24 });
